<div class="filter-section flex flex-col gap-2" [class]="direction">
  <div class="flex justify-between items-center">
    <h3 class="text-base">{{title}}</h3>
    @if (showValue) {
      <span class="value-with-input">
        <input type="number" class="value-input" [value]="value" [max]="max" min="0"
          (input)="onValueInput($event)" /> {{mintuesText}}
      </span>
    }
  </div>
  <ng-content></ng-content>
  @if (!!addDivider) {
    <mat-divider />
  }
</div>